import { api } from '../../api/endpoints'
import { clearDeviceState } from '../../app/lifecycle'
import { nativePlatform } from '../../native/native'
import { disableNativePush } from '../../native/nativePush'
import { endNativeBrowserSession } from '../../native/signIn'
import { unsubscribeLocally } from '../../push/push'

/** POST /auth/logout → clear local data, push and caches → go to the returned URL. */
export async function signOut(): Promise<void> {
  const app = nativePlatform()
  // In the app the push token goes first: removing it needs the session.
  if (app) await disableNativePush()
  let redirectUrl = '/'
  try {
    const res = await api.logout(app ?? undefined)
    if (res?.redirectUrl) redirectUrl = res.redirectUrl
  } catch {
    // Still clear this device if the server call fails.
  }
  await unsubscribeLocally()
  await clearDeviceState()
  if (app) {
    // Keycloak's session is in the system browser: end it there too, so the next person on this phone is not signed in as this one.
    if (redirectUrl !== '/') await endNativeBrowserSession(redirectUrl)
    window.location.assign('/')
    return
  }
  window.location.assign(redirectUrl)
}

/** DELETE /api/me/sessions signs out every device, including this one. */
export async function signOutEverywhere(): Promise<void> {
  if (nativePlatform()) await disableNativePush()
  await api.revokeAllSessions()
  await unsubscribeLocally()
  await clearDeviceState()
  window.location.assign('/')
}
